import React from "react";
import "./TextSvisle.css";
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

const textSvisle = props => {
  let image = null;
   console.log(props)

   
  if (props.img) {
    image = <img id="SvisleImg" onClick={() => props.onShowModal(props.img)} src={props.img} alt="test" />;
  }

  return (
    <div className="KurzPopis">
      <h4 className="KurzTextSvisleNadpis">{props.name}</h4>

      {image}

      <p className="KurzTextPole">
        {props.text}
      </p>
    </div>
  );
};

// const mapStateToProps = state => {
//   return {
//     text: state.text.textSvis
//   }
// }

const mapDispatchToProps = dispatch => {
  return {
    onShowModal: (img) => dispatch(actions.showModal(img))

  }
}


export default connect(null,mapDispatchToProps)(textSvisle);
